/**
 * Visualizador de relatório HTML em modal (iframe do artefato + Imprimir +
 * Baixar HTML) — o padrão do Espelho da Folha (R1), extraído para reuso pelos
 * relatórios de processamentos (P1: recibo de férias e relatório de 13º).
 */
import { Button, Group, Modal } from "@mantine/core";
import { IconDownload, IconPrinter } from "@tabler/icons-react";
import { urlComToken } from "../api";

export interface RelatorioAberto {
  artefatoId: string;
  nomeArquivo: string;
  titulo: string;
}

export function VisualizadorRelatorio({
  relatorio,
  onFechar,
}: {
  relatorio: RelatorioAberto | null;
  onFechar: () => void;
}) {
  return (
    <Modal
      opened={relatorio !== null}
      onClose={onFechar}
      title={relatorio ? `${relatorio.titulo} — ${relatorio.nomeArquivo}` : ""}
      size="90%"
      centered
    >
      {relatorio && (
        <>
          <Group justify="flex-end" mb="sm">
            <Button
              variant="light"
              leftSection={<IconPrinter size={16} />}
              onClick={() => {
                const frame = document.getElementById("iframe-relatorio") as HTMLIFrameElement | null;
                frame?.contentWindow?.print();
              }}
            >
              Imprimir
            </Button>
            <Button
              component="a"
              href={urlComToken(`/artefatos/${relatorio.artefatoId}/download`)}
              download={relatorio.nomeArquivo}
              leftSection={<IconDownload size={16} />}
            >
              Baixar HTML
            </Button>
          </Group>
          <iframe
            id="iframe-relatorio"
            src={urlComToken(`/artefatos/${relatorio.artefatoId}/download`)}
            title={relatorio.titulo}
            style={{ width: "100%", height: "70vh", border: "1px solid var(--mantine-color-gray-3)", borderRadius: 8 }}
          />
        </>
      )}
    </Modal>
  );
}

/** Badge de estado do PROCESSAMENTO (P1 — ciclo próprio, cores distintas da
 *  competência: aberto = azul, calculado = amarelo, fechado = cinza). */
import { Badge } from "@mantine/core";
import { ROTULO_ESTADO_PROCESSAMENTO } from "../format";

const COR_ESTADO_PROC: Record<string, string> = {
  aberto: "blue",
  calculado: "yellow",
  fechado: "gray",
};

export function BadgeEstadoProcessamento({ estado, size = "md" }: { estado: string; size?: "xs" | "sm" | "md" | "lg" }) {
  return (
    <Badge size={size} color={COR_ESTADO_PROC[estado] ?? "gray"}>
      {ROTULO_ESTADO_PROCESSAMENTO[estado] ?? estado}
    </Badge>
  );
}
